import { StreamersBanner } from '@/hooks/content';
import Image from 'next/image';
import { Badge } from '@/components';
import Link from 'next/link';

export const Banners = ({ banners }: { banners: StreamersBanner[] }) => {
  return (
    <div
      className={`grid grid-cols-[1fr] md:grid-cols-[1fr_1fr] lg:grid-cols-[1fr_1fr_1fr] w-full justify-between relative my-6 text-primary font-medium font-secondary gap-4`}
    >
      {banners.map(({ backgroundImage, icon, title, description, buttonLink, buttonText, label }) => (
        <div
          key={title}
          className="flex flex-col justify-between gap-3 py-3.5 pt-0 flex-1 border border-neutral-900 rounded-2xl overflow-hidden min-h-[286px]"
        >
          <div className="flex flex-col">
            <div className="flex flex-row gap-2 text-neutral-100 text-lg items-center justify-between">
              <div className="flex flex-col items-center gap-2 w-full">
                <div
                  style={{ ['--image-url' as string]: `url(${backgroundImage})` }}
                  className="flex gap-x-2 items-center justify-center h-[66px] mb-5 w-full bg-center bg-cover bg-[image:var(--image-url)] bg-no-repeat"
                >
                  {icon && <Image src={icon} width={32} height={32} alt="Icn" className="h-auto" />}
                  {label && (
                    <Badge className="font-medium text-sm border border-sky-500 bg-sky-600/5 uppercase text-sky-600">
                      {label}
                    </Badge>
                  )}
                </div>
                <div className="text-white tracking-wide text-lg px-8">
                  {title && <span className="uppercase">{title}</span>}
                </div>
              </div>
            </div>
            {description && (
              <div className={`font-sans text-grey-300 text-sm font-normal px-8 text-center`}>{description}</div>
            )}
          </div>
          {buttonText && buttonLink && (
            <Link className="w-full pt-4 pb-6 px-6" href={buttonLink} target="_blank">
              <button className="w-full bg-[#DFE0E10A] border border-grey-850 text-grey-100 rounded-lg px-4 py-2 text-sans font-medium text-base">
                {buttonText}
              </button>
            </Link>
          )}
        </div>
      ))}
    </div>
  );
};
